module.exports = __webpack_public_path__ + "img/hint-game.ebe3560b.svg";